module.exports = __webpack_public_path__ + "img/call-center-status.5fce087b.png";